import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { Pages } from 'constants/menu';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTaskTabForTask } from './taskTabs';

export const getTaskLink = (task: AutopilotTaskDto): string | undefined => {
  const { campaignId, contractId, category, agencyId } = task;
  if (!agencyId || !campaignId) return;

  const campaignPath = `/${Pages.AGENCIES}/${agencyId}/${Pages.CAMPAIGNS}/${campaignId}`;
  const taskPath = contractId
    ? `${campaignPath}/${Pages.CONTRACTS}/${contractId}/${Pages.CONTRACT_TASKS}`
    : `${campaignPath}/${Pages.CAMPAIGN_TASKS}`;

  return `${taskPath}${category?.workflowType ? `#tab=${getTaskTabForTask(task)}` : ''}`;
};

export const useNavigateToTask = () => {
  const navigate = useNavigate();

  const navigateToTask = useCallback(
    (task: AutopilotTaskDto) => {
      if (!task) return;

      const to = getTaskLink(task);
      if (to) navigate(to);
    },
    [navigate]
  );

  return navigateToTask;
};
